import { gql, useQuery } from "@apollo/client";
import { useMemo } from "react";

export const GET_ROLES = gql`
  query getRoles($include_saml: Boolean!) {
    roles {
      edges {
        node {
          id
          name
          saml_user_groups @include(if: $include_saml)
        }
      }
    }
  }
`;

interface RoleNode {
  id: string;
  name: string;
  saml_user_groups?: string[];
}

interface GetRolesData {
  roles: {
    edges: Array<{ node: RoleNode }>;
  };
}

interface GetRolesVariables {
  include_saml: boolean;
}

export interface Role extends RoleNode {
  label: string;
  value: string;
}

interface UseRolesReturn {
  roles: Role[];
  rolesLoading: boolean;
}

const useRoles = (withSamlUserGroups = false): UseRolesReturn => {
  const { data: rolesData, loading } = useQuery<
    GetRolesData,
    GetRolesVariables
  >(GET_ROLES, {
    variables: { include_saml: withSamlUserGroups },
  });

  const roles = useMemo<Role[]>(() => {
    if (!!rolesData) {
      return rolesData?.roles?.edges.map(({ node }) => {
        return {
          ...node,
          label: node.name,
          value: node.id,
        };
      });
    }

    return [];
  }, [rolesData]);

  return { roles, rolesLoading: loading };
};

export default useRoles;
